export default "__VITE_ASSET__C$rS_7wf__"